import { render, staticRenderFns } from "./Notif.vue?vue&type=template&id=057befa2&scoped=true&"
import script from "./Notif.vue?vue&type=script&lang=ts&"
export * from "./Notif.vue?vue&type=script&lang=ts&"
import style0 from "./Notif.vue?vue&type=style&index=0&id=057befa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057befa2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('057befa2')) {
      api.createRecord('057befa2', component.options)
    } else {
      api.reload('057befa2', component.options)
    }
    module.hot.accept("./Notif.vue?vue&type=template&id=057befa2&scoped=true&", function () {
      api.rerender('057befa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Drawer/Notif.vue"
export default component.exports